import { render, staticRenderFns } from "./BasicInformation.vue?vue&type=template&id=684fd4c6&scoped=true"
import script from "./BasicInformation.vue?vue&type=script&lang=ts"
export * from "./BasicInformation.vue?vue&type=script&lang=ts"
import style0 from "./BasicInformation.vue?vue&type=style&index=0&id=684fd4c6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684fd4c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('684fd4c6')) {
      api.createRecord('684fd4c6', component.options)
    } else {
      api.reload('684fd4c6', component.options)
    }
    module.hot.accept("./BasicInformation.vue?vue&type=template&id=684fd4c6&scoped=true", function () {
      api.rerender('684fd4c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/ClientRightSide/BasicInformation.vue"
export default component.exports